import * as React from "react";
import { forwardRef } from "react";
const SvgArrowNext = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 10 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.063 9.8 4.037 8.756 7.16 5.632H0V4.173h7.16L4.037 1.049 5.063 0l4.9 4.9z", "data-name": "icon/arrownext2", transform: "rotate(90 4.915 4.95)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgArrowNext);
export { ForwardRef as ReactComponent };
